import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiShoppingBag, FiTag, FiTruck, FiZap, FiCheckCircle } from "react-icons/fi";

const FeaturesPage = () => {
  const navigate = useNavigate();
  const [rotatedText, setRotatedText] = useState("Anything");
  const [activeTab, setActiveTab] = useState("buyer");
  
  const words = ["Anything", "Everything", "ASAP⚡"];

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      i = (i + 1) % words.length;
      setRotatedText(words[i]);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  const tabs = [
    { id: "buyer", label: "Buyer", icon: <FiShoppingBag /> },
    { id: "seller", label: "Seller", icon: <FiTag /> },
    { id: "rider", label: "Rider", icon: <FiTruck /> },
  ];

  const content = {
    buyer: [
      "Refundable products from OurASAP sellers",
      "Negotiate directly with sellers in-app",
      "Secure payments held until delivery",
      "100% product insurance & full refunds",
      "Access to both new and used products",
      "Delivery fully handled by OurASAP",
      "Send Errands, not just packages",
      "Connect with local delivery services",
    ],
    seller: [
      "Zero upfront ads payments",
      "Post unlimited number of products",
      "High buyer visibility through platform",
      "Show up to 25 product images",
      "Secure collection via OurASAP agents",
      "Instant payout upon product collection",
      "3-day withdrawal after delivery",
      "Low 3% fee (We handle payment & delivery)",
    ],
    rider: [
      "Guaranteed secure rider payments",
      "Smart nearby assignment system",
      "Preview tasks before accepting",
      "Full payment for completed errands",
      "Fair & reliable dispatch system",
      "Real-time route optimization",
    ],
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col relative overflow-hidden">
      {/* Decorative Blur */}
      <div className="absolute top-[-5%] right-[-10%] w-80 h-80 bg-orange-100 rounded-full blur-3xl opacity-40"></div>

      {/* Header */}
      <div className="bg-white px-6 py-6 flex items-center shadow-sm border-b border-gray-100 relative z-20">
        <button 
          onClick={() => navigate(-1)} 
          className="p-2 -ml-2 hover:bg-gray-100 rounded-full transition text-gray-900"
        >
          <IoMdArrowBack size={24} />
        </button>
        <div className="ml-4">
          <h1 className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-600">Platform</h1>
          <p className="text-xl font-black text-gray-900 tracking-tighter">Features & Benefits</p>
        </div>
      </div>

      <div className="flex-1 p-4 max-w-2xl mx-auto w-full relative z-10 pt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-6 md:p-10 shadow-xl shadow-gray-200/50 border border-gray-100">
          
          {/* Animated Slogan */}
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-orange-50 px-4 py-2 rounded-full mb-4">
               <FiZap className="text-orange-600 animate-pulse" />
               <span className="text-[10px] font-black uppercase tracking-widest text-orange-600">Buy, Sell, Deliver</span>
            </div>
            <h2 className="text-3xl font-black text-gray-900 tracking-tighter">
              Get <span key={rotatedText} className="text-orange-600 animate-fade-in-up inline-block">{rotatedText}</span>
            </h2>
          </div>

          {/* Tab Navigation */}
          <div className="flex p-1 bg-gray-100 rounded-2xl mb-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all ${
                  activeTab === tab.id 
                    ? "bg-white text-orange-600 shadow-sm" 
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                {tab.icon} {tab.label}
              </button>
            ))}
          </div>

          {/* Feature List */}
          <div className="space-y-4 min-h-[400px]">
            {content[activeTab].map((item, index) => (
              <div 
                key={index} 
                className="flex items-start gap-4 p-4 rounded-2xl bg-gray-50 border border-transparent hover:border-orange-100 transition-all group"
              >
                <div className="mt-1">
                  <FiCheckCircle className="text-orange-600 group-hover:scale-110 transition-transform" size={18} />
                </div>
                <p className="text-sm font-bold text-gray-700 leading-snug">
                  {item}
                </p>
              </div>
            ))}
          </div>

          {/* Bottom Callout */}
          <div className="mt-10 pt-8 border-t border-gray-100">
            <div className="bg-gray-900 rounded-3xl p-6 flex items-center justify-between gap-4">
                <div>
                    <h4 className="text-white text-xs font-black uppercase tracking-widest">OurASAP Fee</h4>
                    <p className="text-gray-400 text-[10px] font-bold">Only 3% per successful sale from seller</p>
                </div>
                <div className="bg-orange-600 text-white px-4 py-2 rounded-xl font-black text-sm">
                    3%
                </div>
            </div>
          </div>

          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest text-center mt-8">
            &copy; {new Date().getFullYear()} OurASAP. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeaturesPage;
